import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { RCardExtended } from '../style';

const ResponseCardLoader = () => (
  <RCardExtended>
    <div className="row">
      <div className="user-info">
        <Skeleton width={50} height={50} />
        <div style={{ marginLeft: '12px' }}>
          <Skeleton width={250} height={22} style={{ marginTop: '5px' }} />
          <br />
          <Skeleton width={100} height={12} />
        </div>
      </div>
      <div className="time-rating">
        <Skeleton width={150} height={15} style={{ marginTop: '10px' }} />
      </div>
    </div>
    <div className="content">
      {[1, 2].map((item) => (
        <p className="response-loader" key={item}>
          <div className="question">
            <Skeleton width="50%" height={16} />
            <Skeleton width="80%" height={14} />
          </div>
        </p>
      ))}
    </div>
  </RCardExtended>
);

export default ResponseCardLoader;
